/* Ecochic en Eurus — portado de web-v3/js/consulta.js (FLUJO_FRONTEND_ECOCHIC_v1 §6, §9, §10). Solo navegador (fase 1). */
/* consulta.js — E6 · "Consulta con Ecochic" (asíncrona, Fase 1 del H5).
   Formulario de consulta preventa. Se envía con el formulario de contacto de Shopify al correo de la
   tienda (decisión 30-09). Muestra confirmación accesible al volver.

   FRONTERAS (H5 / lenguaje AEMPS):
   - Disclaimer fijo en el propio form: respondemos sobre cosmética y uso; NO es consejo médico ni
     diagnóstico; NO incluir datos de salud. Lenguaje AEMPS (nada de curar/tratar patologías).
   - Destino real (buzón de email / helpdesk) y WhatsApp con enlace directo = ⬜ PRODUCCIÓN: exige
     base legal (Art. 9 si el usuario describe su piel), DPIA, minimización y retención definida.

   API: window.Consulta.open({product}) — product opcional (preselecciona el asunto desde una ficha). */
(function(){ "use strict";
  window.Consulta = window.Consulta || {};

  /* Envío real: formulario de contacto de Shopify (#eco-consulta-shopify, snippet eco-consulta-form) → correo de la tienda */
  var CQ = window.__ecoConsulta || {};
  function shopifyForm(){ return document.getElementById('eco-consulta-shopify'); }
  function esc(s){ return (window.UI&&UI.esc)?UI.esc(s):String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function isEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function injectStyles(){
    if(document.getElementById('eco-consulta-css')) return;
    var s=document.createElement('style'); s.id='eco-consulta-css';
    s.textContent=[
      '.cq-ov{position:fixed;inset:0;z-index:80;background:rgba(43,43,43,.5);display:flex;align-items:flex-end;justify-content:center;padding:0}',
      '@media(min-width:641px){.cq-ov{align-items:center;padding:24px}}',
      '.cq-dlg{background:rgb(var(--colors-background));color:rgb(var(--colors-text));width:100%;max-width:520px;max-height:92vh;overflow:auto;border-radius:16px 16px 0 0;padding:22px 20px calc(22px + env(safe-area-inset-bottom))}',
      '@media(min-width:641px){.cq-dlg{border-radius:16px}}',
      '.cq-head{display:flex;justify-content:space-between;align-items:flex-start;gap:12px;margin-bottom:4px}',
      '.cq-head h3{margin:0;font-size:19px}',
      '.cq-x{border:none;background:none;font-size:26px;line-height:1;cursor:pointer;color:var(--ink);padding:0 4px;min-height:44px}',
      '.cq-sub{font-size:13.5px;color:var(--ink-soft);margin:2px 0 14px;line-height:1.5}',
      '.cq-dis{border:1px solid var(--line);background:var(--bg2);border-radius:10px;padding:12px 14px;font-size:12.5px;color:var(--ink-soft);line-height:1.55;margin:0 0 16px}',
      '.cq-dis b{color:var(--ink)}',
      '.cq-f{display:grid;gap:12px}',
      '.cq-fld label{display:block;font-size:13px;font-weight:600;color:var(--ink);margin-bottom:6px}',
      '.cq-fld .req{color:var(--muted);font-weight:400}',
      '.cq-fld input,.cq-fld textarea{display:block;width:100%;padding:12px 13px;border:1px solid var(--line);border-radius:9px;font-family:inherit;font-size:15px;background:rgb(var(--colors-background));color:rgb(var(--colors-text))}',
      '.cq-fld textarea{resize:vertical;min-height:88px}',
      '.cq-fld input:focus-visible,.cq-fld textarea:focus-visible{outline:2px solid var(--ink);outline-offset:2px}',
      '.cq-fld.bad input,.cq-fld.bad textarea{border-color:#9a5a2a}',
      '.cq-err{font-size:12.5px;color:#9a5a2a;font-weight:600;margin-top:5px;display:none}',
      '.cq-fld.bad .cq-err{display:block}',
      '.cq-prod{font-size:13px;color:var(--ink-soft);background:var(--bg2);border:1px solid var(--line);border-radius:9px;padding:10px 12px}',
      '.cq-prod b{color:var(--ink)}',
      '.cq-acts{display:flex;gap:10px;flex-wrap:wrap;margin-top:4px}',
      '.cq-acts .btn{min-height:46px}',
      '@media(max-width:640px){.cq-acts .btn{width:100%}}',
      '.cq-note{font-size:11.5px;color:var(--muted);line-height:1.5;margin:10px 0 0}',
      '.cq-ok{text-align:center;padding:12px 4px}',
      '.cq-ok .oi{width:46px;height:46px;border-radius:50%;border:2px solid var(--ink);display:flex;align-items:center;justify-content:center;margin:0 auto 14px;color:var(--ink)}',
      '.cq-ok .oi svg{width:22px;height:22px}',
      '.cq-ok h3{margin:0 0 8px}.cq-ok p{color:var(--ink-soft);font-size:14px;max-width:40ch;margin:0 auto 16px;line-height:1.5}',
      '.cq-ov :focus-visible{outline:2px solid var(--ink);outline-offset:2px}'
    ].join('');
    document.head.appendChild(s);
  }

  window.Consulta.open=function(opts){
    injectStyles();
    opts=opts||{}; var product=opts.product||null;
    var prevFocus=document.activeElement;
    var ov=document.createElement('div');
    ov.className='cq-ov'; ov.setAttribute('role','dialog'); ov.setAttribute('aria-modal','true'); ov.setAttribute('aria-labelledby','cqTitle');
    var prodField = product && (product.t||product.h)
      ? '<div class="cq-prod">'+EcoT('consulta.sobre')+' <b>'+esc(product.t||product.h)+'</b>'+(product.brand?' · '+esc(product.brand):'')+'</div>'
      : '';
    ov.innerHTML=''+
      '<div class="cq-dlg">'+
        '<div class="cq-head"><h3 id="cqTitle">'+EcoT('consulta.consulta_con_ecochic')+'</h3>'+
          '<button type="button" class="cq-x" id="cqX" aria-label="'+EcoT('consulta.cerrar_consulta')+'">&times;</button></div>'+
        '<p class="cq-sub">'+EcoT('consulta.dudas_sobre_si_un_producto_te_encaja_o')+'</p>'+
        '<div class="cq-dis">'+EcoT('consulta.respondemos_sobre')+' <b>'+EcoT('consulta.cosmetica_y_uso_de_productos')+'</b>. <b>'+EcoT('consulta.no_es_consejo_medico_ni_diagnostico')+'</b>: '+
          EcoT('consulta.para_afecciones_de_la_piel_acude_a_tu')+' <b>'+EcoT('consulta.no_incluyas_datos_de_salud')+'</b> '+EcoT('consulta.en_tu_consulta')+'</div>'+
        '<form class="cq-f" id="cqForm" novalidate>'+
          prodField+
          '<div class="cq-fld"><label for="cqName">'+EcoT('consulta.nombre')+' <span class="req">'+EcoT('consulta.opcional')+'</span></label>'+
            '<input id="cqName" name="name" type="text" autocomplete="name"></div>'+
          '<div class="cq-fld" id="cqEmailFld"><label for="cqEmail">'+EcoT('consulta.email')+' <span class="req">'+EcoT('consulta.para_poder_responderte')+'</span></label>'+
            '<input id="cqEmail" name="email" type="email" autocomplete="email" inputmode="email" required aria-required="true">'+
            '<div class="cq-err">'+EcoT('consulta.introduce_un_email_valido_nombre_domin')+'</div></div>'+
          '<div class="cq-fld" id="cqMsgFld"><label for="cqMsg">'+EcoT('consulta.tu_consulta')+'</label>'+
            '<textarea id="cqMsg" name="msg" placeholder="'+EcoT('consulta.ej_este_limpiador_va_bien_si_uso_retin')+'" required aria-required="true"></textarea>'+
            '<div class="cq-err">'+EcoT('consulta.escribe_tu_consulta')+'</div></div>'+
          '<div class="cq-acts"><button type="submit" class="button button-solid eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3">'+EcoT('consulta.enviar_consulta')+'</button>'+
            '<button type="button" class="button button-outline eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3" id="cqCancel">'+EcoT('consulta.cancelar')+'</button></div>'+
          '<p class="cq-note">'+EcoT('consulta.nota_envio')+'</p>'+
        '</form>'+
      '</div>';
    document.body.appendChild(ov);
    var dlg=ov.querySelector('.cq-dlg');

    function close(){ if(ov.parentNode) ov.parentNode.removeChild(ov); document.removeEventListener('keydown',onKey); try{ prevFocus&&prevFocus.focus(); }catch(e){} }
    function focusables(){ return Array.prototype.filter.call(
      ov.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function(el){ return el.offsetParent!==null; }); }
    function onKey(e){
      if(e.key==='Escape'){ close(); return; }
      // aria-modal: atrapa el foco dentro del diálogo (Tab cicla; Shift+Tab hacia atrás)
      if(e.key==='Tab'){
        var f=focusables(); if(!f.length) return; var first=f[0], last=f[f.length-1];
        if(e.shiftKey && document.activeElement===first){ e.preventDefault(); try{ last.focus(); }catch(_){} }
        else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); try{ first.focus(); }catch(_){} }
      }
    }
    document.addEventListener('keydown',onKey);
    ov.addEventListener('mousedown',function(e){ if(e.target===ov) close(); });
    ov.querySelector('#cqX').addEventListener('click',close);
    ov.querySelector('#cqCancel').addEventListener('click',close);
    var emailEl=ov.querySelector('#cqEmail'); var nameEl=ov.querySelector('#cqName');
    if(emailEl&&CQ.email) emailEl.value=CQ.email; if(nameEl&&CQ.name) nameEl.value=CQ.name;
    var msgEl=ov.querySelector('#cqMsg'); if(CQ.email&&msgEl) msgEl.focus(); else if(emailEl) emailEl.focus();

    ov.querySelector('#cqForm').addEventListener('submit',function(e){
      e.preventDefault();
      var email=ov.querySelector('#cqEmail'), msg=ov.querySelector('#cqMsg');
      var okEmail=isEmail((email.value||'').trim()); var okMsg=(msg.value||'').trim().length>0;
      ov.querySelector('#cqEmailFld').classList.toggle('bad',!okEmail);
      ov.querySelector('#cqMsgFld').classList.toggle('bad',!okMsg);
      email.setAttribute('aria-invalid',okEmail?'false':'true'); msg.setAttribute('aria-invalid',okMsg?'false':'true');
      if(!okEmail){ email.focus(); return; }
      if(!okMsg){ msg.focus(); return; }
      var F=shopifyForm();
      if(F){
        var set=function(n,v){ var el=F.querySelector('[name="'+n+'"]'); if(el) el.value=v||''; };
        // campos con nombre traducible (consulta.campo_*): se localizan por data-cq, no por su nombre visible
        var setC=function(k,v){ var el=F.querySelector('[data-cq="'+k+'"]'); if(el) el.value=v||''; };
        setC('origen',EcoT('consulta.origen'));
        set('contact[name]',(ov.querySelector('#cqName').value||'').trim());
        set('contact[email]',email.value.trim());
        setC('producto',product?((product.t||product.h)+(product.brand?' · '+product.brand:'')):'');
        setC('pagina',location.pathname);
        set('contact[body]',msg.value.trim());
        try{ sessionStorage.setItem('eco_cq_sent',email.value.trim()); }catch(_){}
        var sb=ov.querySelector('button[type=submit]'); if(sb){ sb.disabled=true; sb.textContent=EcoT('consulta.enviando'); }
        HTMLFormElement.prototype.submit.call(F);
        return;
      }
      showDone(email.value.trim());
    });
    function showDone(addr){
      dlg.innerHTML='<div class="cq-ok"><div class="oi" aria-hidden="true">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg></div>'+
        '<h3 id="cqTitle">'+EcoT('consulta.consulta_recibida')+'</h3>'+
        '<p>'+EcoT('consulta.gracias_te_responderemos_a')+' <b>'+esc(addr)+'</b> '+EcoT('consulta.sobre_tu_duda_de_producto_o_uso')+'</p>'+
        '<button type="button" class="button button-solid eco-btn leading-normal text-center pl-7 pr-7 pt-2.5 pb-2.5 md:pl-8 md:pr-8 md:pt-3 md:pb-3" id="cqOk">'+EcoT('consulta.cerrar')+'</button></div>';
      var okb=dlg.querySelector('#cqOk'); if(okb){ okb.addEventListener('click',close); okb.focus(); }
    }
    if(opts.done) showDone(opts.done);
    if(opts.error){ var er=document.createElement('p'); er.className='cq-note'; er.setAttribute('role','alert'); er.textContent=EcoT('consulta.no_se_pudo_enviar'); var fm=ov.querySelector('#cqForm'); if(fm) fm.insertBefore(er,fm.firstChild); }
  };

  /* al volver del envío de Shopify: confirmación (o aviso de error) en el mismo diálogo */
  var sentTo=null; try{ sentTo=sessionStorage.getItem('eco_cq_sent'); }catch(_){}
  if(sentTo && (CQ.sent || CQ.error)){
    try{ sessionStorage.removeItem('eco_cq_sent'); }catch(_){}
    var go=function(){ window.Consulta.open(CQ.sent?{done:sentTo}:{error:true}); };
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
  }
})();
